const notNull = (val: any) => !(val === null);

export default notNull;
